import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import DefendantDialog from './DefendantDialog';
import DefendantGrid from './DefendantGrid';

const DefendantsPage = () => {
    const [refreshKey, setRefreshKey] = useState(0);

    const handleDefendantSaved = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h4">Defendants</Typography>
                <DefendantDialog onSaved={handleDefendantSaved} />
            </Box>
            <DefendantGrid autoHeight refreshKey={refreshKey} />
        </Box>
    );
};

export default DefendantsPage;
